import React, { createContext, MutableRefObject, useContext, useRef, useState } from 'react';
import { ConversationKey } from '../models';
import { ConversationsFilter } from '../types';

export type ConfirmCancellationStoredData =
    | ConversationsFilter
    | ConversationKey
    | 'bookmarks-view';

type NewConversationCancellationModalContextValue = {
    isOpen?: boolean;
    setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
    confirmCancellationStoredData?: MutableRefObject<ConfirmCancellationStoredData | undefined>;
    updateConfirmCancellationStoredData?: (newData?: ConfirmCancellationStoredData) => void;
};

const NewConversationCancellationModalContext = createContext<
    NewConversationCancellationModalContextValue | undefined
>(undefined);

export const NewConversationCancellationModalProvider: React.FC = ({ children }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const confirmCancellationStoredData = useRef<ConfirmCancellationStoredData | undefined>();
    const updateConfirmCancellationStoredData = (newData?: ConfirmCancellationStoredData) => {
        confirmCancellationStoredData.current = newData;
    };

    return (
        <NewConversationCancellationModalContext.Provider
            value={{
                isOpen,
                setIsOpen,
                confirmCancellationStoredData,
                updateConfirmCancellationStoredData,
            }}
        >
            {children}
        </NewConversationCancellationModalContext.Provider>
    );
};

export const useNewConversationCancellationModalContext = () => {
    const newConversationCancellationModalContext = useContext(
        NewConversationCancellationModalContext
    );
    return newConversationCancellationModalContext;
};
